import React, { useContext } from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table } from "react-bootstrap";
import { Context } from "../../../../../../../utils/context";

function Order_details_table({ order, dontShowPrice }) {
   const {
      IMG_URL,
      signin,
      triggerCartUpdate,
      setTaxRupees,
      taxRupees,
      userdata,
    } = useContext(Context);
  return (
    <>
      <div className="product_content_holder">
        <div className="product_content">
          <div className="product_detail_inner">
            <div className="left_side">
              <div className="img_holder">
                <img
                  src={
                    IMG_URL +order?.product?.image1
                  }
                />
              </div>

              <div className="text_holder">
                <div className="product_name">
                  <p>{order?.product?.name}</p>
                </div>
                <div className="weight">
                  <p>{order?.product_variant?.v_name}</p>
                </div>
              </div>
            </div>

            <div>
              <div className="qty_holder">
                <p>
                  x {order?.quantity}{" "}
                  {!dontShowPrice && (
                    <span className="price">
                      ₹ {order?.product_variant?.s_price}
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
          {order?.order_addOns?.map((val) => (
            <div className="text_holder">
              <div className="product_name">
                <p>
                  <b>Add On</b>
                </p>
              </div>
              <div className="weight">
                <p>{val?.product_addOn?.name}-{val?.price}</p>
              </div>
            </div>
          ))}

          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                      "/assets/Image/product/home.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Apple</p>
                </div>
                <div className='weight'>
                  <p>0.5kg</p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
               <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}
        </div>
      </div>
    </>
  );
}

export default Order_details_table;
